export const CITY_LIST_ATTEMP = 'CITY_LIST_ATTEMP';
export const CITY_LIST_SUCCESS = 'CITY_LIST_SUCCESS';
export const CITY_LIST_FAILED = 'CITY_LIST_FAILED';
